export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: 'faq-1',
    question: '网站的剧集可以免费观看吗？',
    answer:
      '本站聚焦《迷人的保姆》的剧集信息与剧情介绍，页面内的播放区域为功能演示，用于展示观看界面与交互效果，不提供真实视频源。',
  },
  {
    id: 'faq-2',
    question: '如何知道剧集有没有更新？',
    answer:
      '首页的“最新剧集更新”会按时间倒序展示最近上线的章节，详情页也会标注当前更新至第几集以及每周的更新安排。',
  },
  {
    id: 'faq-3',
    question: '收藏的内容保存在哪里？',
    answer:
      '收藏与浏览记录保存在你当前使用的浏览器本地，不会上传到服务器，也不需要注册登录。更换浏览器或清除浏览器数据后记录会消失。',
  },
  {
    id: 'faq-4',
    question: '为什么有些章节显示“待更新”？',
    answer:
      '待更新的章节表示剧情尚未播出，我们会在页面中标注其状态。你可以通过分类页的“待更新”筛选快速查看这些章节。',
  },
  {
    id: 'faq-5',
    question: '如何在手机上使用本站？',
    answer:
      '本站已适配手机浏览，顶部导航会折叠为菜单按钮，分类筛选在移动端以底部弹出面板呈现，页面不会出现横向滚动。',
  },
  {
    id: 'faq-6',
    question: '如何反馈问题或提供建议？',
    answer:
      '你可以通过“关于/帮助”页中的联系邮箱与我们取得联系，我们非常欢迎来自观众的剧情讨论与使用建议。',
  },
];